var map = {
	"./Email.svg": "4NeG",
	"./ads.svg": "SdWw",
	"./check-stock.svg": "AV6z",
	"./checkProduct.svg": "V8v5",
	"./decision.svg": "ruco",
	"./delete-handle.svg": "ZYEG",
	"./drop-shipping.svg": "Bm6s",
	"./dsp-order.svg": "rrFR",
	"./edit-sku.svg": "riyh",
	"./example.svg": "OOLB",
	"./exchange-rage.svg": "Rvbi",
	"./eye.svg": "4wdf",
	"./failed.svg": "Mjqm",
	"./finance.svg": "pTuU",
	"./form.svg": "sTIr",
	"./history-record.svg": "bPga",
	"./history.svg": "nTk5",
	"./home.svg": "U9Ws",
	"./importExcel.svg": "AtEP",
	"./log-list.svg": "Lf/z",
	"./login-mall-otto.svg": "zGqB",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./marketing.svg": "mkJ9",
	"./message.svg": "G2zY",
	"./order-pending.svg": "QXyS",
	"./order-process.svg": "a9Vl",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./packing.svg": "cDBK",
	"./password.svg": "QjmH",
	"./priceCut.svg": "kunW",
	"./priceHigh.svg": "O3wI",
	"./priceList.svg": "DP5x",
	"./processList.svg": "6cMM",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./promotion.svg": "HzCk",
	"./publish-setting.svg": "i5yd",
	"./publish.svg": "4rC1",
	"./purchase-list.svg": "YEtW",
	"./purchase.svg": "BM4V",
	"./receive_parcel.svg": "gpAV",
	"./refund.svg": "GeoZ",
	"./reminder.svg": "P8zy",
	"./repair-list.svg": "m8o7",
	"./repair.svg": "V1dC",
	"./replace.svg": "c2f9",
	"./return-list.svg": "/Iut",
	"./sales.svg": "cpHe",
	"./secondary.svg": "GcNI",
	"./service.svg": "nCjf",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./stock-in.svg": "Ti1L",
	"./stock-list.svg": "4L4P",
	"./stock.svg": "t+aG",
	"./system-setting.svg": "3bU4",
	"./table.svg": "oSYw",
	"./talking.svg": "ePpP",
	"./temp.svg": "0ifW",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tracking.svg": "JpB5",
	"./tree.svg": "3eCm",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./user-list.svg": "55Dr",
	"./user.svg": "VdD3",
	"./work-completed.svg": "Cvya"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 118